import { Injectable } from '@angular/core';
import { Observable } from  'rxjs/Rx';

import { ResponsiveState } from 'ng2-responsive';

@Injectable()
export class ResponsoveService {
  public media: string = 'xs';
  public mediaChange: Observable<string>;

  public width: number = 0;
  public widthChange: Observable<number>;

  constructor(private responsive: ResponsiveState) {
    this.mediaChange = this.responsive.elementoObservar;
    this.mediaChange.subscribe(media => this.media = media);

    this.widthChange = this.responsive.anchoObservar;
    this.widthChange.subscribe(width => this.width = width);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/commons/responsive.service.ts